export const AUTHENTICATED: string = 'authenticated_user';
export const UNAUTHENTICATED: string = 'unauthenticated_user';
export const USER_TYPE: string = 'user_type';
export const USER: string = 'user';

